export const PRINTED_BOL_FLAG_TYPES = { NO: 'No', Y: 'yes', YES: 'yes' } as const;
export const SHIPMENT_LOCATION_STOP = { CONSIGNEE: '2', SHIPPER: '1' } as const;

export const SHIPMENT_STATUS = {
  Approved: 'Approved',
  AutoRated: 'Auto-Rated',
  AutoRoute: 'Auto-Route',
  AutoTendered: 'Auto-Tendered',
  BOL: 'BOL',
  Cancelled: 'Cancelled',
  Closed: 'Closed',
  Confirmed: 'Confirmed',
  Hold: 'Hold',
  InTransit: 'In-Transit',
  Invoiced: 'Invoiced',
  New: 'New',
  Partial: 'Partial',
  Planning: 'Planning',
  Quote: 'QUOTE',
  Rated: 'Rated',
  RateError: 'Rate Error',
  Routed: 'Routed',
  SpotBid: 'Spot Bid',
  SpotBidEnd: 'SpotBidEnd',
  Tender: 'Tender',
  Unapproved: 'Unapproved',
} as const;
